import { faPaperclip } from '@fortawesome/pro-light-svg-icons'
import type { ReactElement } from 'react'
import { LabelWithIcon } from '~/components/Global/Elements/LabelWithIcon/LabelWithIcon'
import { useResolveStorageUrl } from '~/domains/messaging/hooks/useResolveStorageUrl'
import { attachmentChip, attachmentList } from './EmailAttachments.css'

type Props = {
  attachments: { filename: string | null; url: string }[]
}

export const EmailAttachments = ({
  attachments
}: Props): ReactElement | null => {
  const resolveUrl = useResolveStorageUrl()

  if (attachments.length === 0) return null

  return (
    <div className={attachmentList}>
      {attachments.map((attachment) => (
        <a
          key={attachment.url}
          href={resolveUrl(attachment.url)}
          target="_blank"
          rel="noopener noreferrer"
          className={attachmentChip}
          title={attachment.filename ?? undefined}
        >
          <LabelWithIcon icon={faPaperclip} truncate>
            {attachment.filename ?? 'Pièce jointe'}
          </LabelWithIcon>
        </a>
      ))}
    </div>
  )
}
